import { useQuery } from 'react-query'
import { axios } from 'lib'
import { toast } from 'react-toastify'
import { PaginatedParams } from 'services/api/types'

const loadOrderPriceTables = (data: PaginatedParams): any => {
  const { page = 1, limit = 10 } = data
  return axios.get(`/orders/price-tables`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderPriceTables(query: any) {
  return useQuery(['orderProduct', query], () => loadOrderPriceTables(query), {
    staleTime: 0,
    cacheTime: 0,
    select: (data) => {
      console.log(data.data)
      console.log(
        data.data.map((item: any) => ({ id: item.id, name: item.description }))
      )
      return data
      // return {
      //   ...data,
      //   data: data.map((item) => ({ id: item.id, name: item.description }))
      // }
    },

    onError: () =>
      toast.error(`Não foi possível carregar as tabelas de preço! `, {
        toastId: 'loadOrderPriceTables'
      })
  })
}
